<template>
  <div
    class="topup_centent"
    v-infinite-scroll="getLoadData"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="10"
  >
    <div class="topup_list" v-if="!loadmore">
      <loading></loading>
    </div>
    <div
      style="min-height: 100%; "
      class=" seek_centent_no_data "
      v-if="list.length <= 0 && busy"
    >
      <div class="no_data_result">
        <div class="no_data_url">
          <img class="no_data_img" src="@/img/tag_air.png" alt />
        </div>
        <div class="no_data_text">{{ $t("config.No_result") }}</div>
      </div>
    </div>
    <div class="topup_list" v-else v-for="(item, index) in list">
      <div class="topup_list_show">
        <div class="topup_list_left">
          <div class="topup_list_gold">
            <img class="topup_list_gold_img" src="@/img/Diamonds.png" alt />
          </div>
          <div class="topup_list_topup">
            <div class="topup_list_topup_title">{{ item.name }}</div>
            <div class="topup_list_sum">{{ NewData(item.date) }}</div>
          </div>
        </div>
        <!-- stop -->
        <div class="sum">
          {{ item.coin }}
        </div>
      </div>
    </div>

    <div class="more_game" v-if="list.length > 0">
      <div class="more_game_height1"></div>
      <div class="loading" v-if="!busy">
        <img class="loading_img" src="@/img/loading.gif" />
        <span class="loading_text">{{ $t("Pay.loading") }}</span>
      </div>
      <div v-if="busy">
        {{ $t("Pay.no_loading") }}
      </div>
      <div class="more_game_height"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import infiniteScroll from "vue-infinite-scroll";
import debounce from "lodash.debounce";
import configs from "@/config/config.js";
import loading from "@/components/config/loading.vue";
export default {
  components: {
    loading
  },
  directives: {
    infiniteScroll
  },
  data() {
    return {
      offset: 0,
      count: 30,
      busy: false,
      list: [],
      loadmore: false
    };
  },
  watch: {},
  created() {
    this.getLoadData = debounce(this._getLoadData, 10);
  },

  mounted() {
    this.$nextTick(function() {
      this.getLoadData();
    });
  },
  methods: {
    ...mapActions("pay", ["CoinList"]),
    NewData(data) {
      return configs.NewData(data);
    },
    async _getLoadData() {
      if (this.busy) {
        return;
      }
      // this.page++;
      // this.busy = true;

      const res = await this.CoinList({
        $axios: this.$axios,
        appId: configs.bipAppId(),
        type: 1,
        offset: this.offset,
        count: this.count
      });
      if (res.stateCode == 1) {
        this.loadmore = true;
        this.offset = this.offset + 1;
        const rList = res.resultInfo.data || [];
        if (this.offset >= 1) {
          this.list = [...this.list, ...rList];
        } else {
          this.list = rList;
        }
        this.busy = res.resultInfo.lastPage;
      }
    }
  }
};
</script>

<style scoped="scoped">
.topup_centent {
  position: absolute;
  top: 1.6rem;
  left: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  overflow: auto;
  background-color: var(--bg);
  border-radius: 0.48rem 0.48rem 0 0;
  padding: 0.49rem 0.49rem 0 0.39rem;
}
.topup_list {
  border-top: var(--billingListBorber);
}
.topup_centent .topup_list:nth-of-type(1) {
  border-top: none;
}
.topup_list_show {
  height: 1.9rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.topup_list_left {
  display: flex;
}
.topup_list_gold {
  margin-right: 0.44rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.topup_list_gold_img {
  width: 0.84rem;
  height: 0.84rem;
}
.topup_list_topup {
}
.topup_list_topup_title {
  width: 6rem;
  font-size: 0.48rem;
  color: var(--billingListColor);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.topup_list_sum {
  margin-top: 0.05rem;
  font-size: 0.36rem;
  color: #999999;
}

.sum {
  color: #ff9c00;
  font-size: 0.54rem;
}

.more_game {
  box-sizing: border-box;
  font-size: 0.25rem;
  width: 100%;
  text-align: center;
  color: var(--rankmore);
  /* padding-top: 0.41rem; */
  /* margin-top: 0.41rem;
         margin-bottom: 1.50rem; */
  opacity: 0.3;
  background-color: var(--bg);
}
.more_game_height {
  width: 100%;
  height: 1rem;
  background-color: var(--bg);
}
.more_game_height1 {
  width: 100%;
  height: 0.6rem;
  background-color: var(--bg);
}

/* 页面加载 */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.loading_img {
  width: 0.3rem;
  height: 0.3rem;
}
.seek_centent_no_data {
  box-sizing: border-box;
  display: flex;
  padding-top: 50%;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/billing/topup.vue